import { action } from 'satcheljs';
import { ActionSource } from 'owa-analytics-actions';

export default action(
    'DELETE_ITEMS_BASED_ON_NODE_IDS',
    (nodeIds: string[], tableViewId: string, actionSource: ActionSource) => ({
        nodeIds,
        tableViewId,
        actionSource,
    })
);
